import { FC } from 'react'
import { times } from 'lodash'
import { CourseType } from '../../../types'
import { CourseListItem } from '..'
import { StyledCourseList } from '.'

type Props = {
  courses: CourseType[]
  loading?: boolean
}

const CourseList: FC<Props> = ({ courses, loading }) => {
  return (
    <StyledCourseList>
      {courses.map((course) => {
        return <CourseListItem course={course} key={course._id} />
      })}
      {loading &&
        times(4, (index) => {
          return (
            <div className="skel" key={index}>
              <div />
              <div>
                <div>
                  <div />
                  <div />
                </div>
                <div />
              </div>
            </div>
          )
        })}
    </StyledCourseList>
  )
}

export default CourseList
